var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({class:_vm.cssClass,attrs:{"outlined":_vm.outline,"depressed":"","rounded":"","color":_vm.color},on:{"click":_vm.scrollTo}},'v-btn',_vm.linkProps(_vm.url),false),[_vm._t("default",[_vm._v("Lees meer")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }